import React, { Component } from "react";

class Home extends Component {
    render(){
        return(
            <div className = "content-wrapper">
            <p className="pageContent">hello, home</p>
            <div class="push"></div>
            </div>
        )
    }
}

export default Home;